module.exports = __webpack_public_path__ + "static/media/polygon-grey.2a7af3e4.svg";